import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import SubscriptionBanner from '../../components/SubscriptionBanner/SubscriptionBanner'
// import SubscriptionBlock from '../../components/SubscriptionBlock/SubscriptionBlock'
import { useAppStore } from '../../store/useAppStore'
import { apiClient } from '../../services/apiClient'
import { useTelegramBackButton } from '../../hooks/useTelegramBackButton'
import type { SubscriptionPrice } from '../../types/api'
import './SubscribePage.css'
import '../CardPage/CardPage.css'
import subscribeHero from '../../assets/images/subPage/secret.png'
import image1 from '../../assets/images/subPage/{8153C883-DBCC-46D4-8742-C90292C7AAB7} 1.png'
import image2 from '../../assets/images/subPage/{8153C883-DBCC-46D4-8742-C90292C7AAB7} 2.png'
import image3 from '../../assets/images/subPage/{CB848B3F-7D23-451C-AE61-4A46FA36630D} 1.png'
import image4 from '../../assets/images/subPage/{8153C883-DBCC-46D4-8742-C90292C7AAB7} 3.png'
import image5 from '../../assets/images/subPage/{8153C883-DBCC-46D4-8742-C90292C7AAB7} 4.png'
import image6 from '../../assets/images/subPage/{CB848B3F-7D23-451C-AE61-4A46FA36630D} 2.png'
import image7 from '../../assets/images/subPage/{14EFEA54-4BFC-467A-BC26-D8AF8F92B117} 1.png'
import image8 from '../../assets/images/subPage/{14EFEA54-4BFC-467A-BC26-D8AF8F92B117} 2.png'
import image9 from '../../assets/images/subPage/video1.png'
import image10 from '../../assets/images/subPage/video2.png'
import chanel from '../../assets/images/subPage/chanel.png'
import massage1 from '../../assets/images/subPage/massege1.png'
import massage2 from '../../assets/images/subPage/massege2.png'
import massage3 from '../../assets/images/subPage/massege3.png'
import cloude from '../../assets/images/subPage/cloud.svg'
import { ImageSlider } from '../CardPage/components'
import PaymentModal from '../ProfilePage/components/PaymentModal'
import { PaymentCurrency } from '../ProfilePage/constants/paymentLinks'

const SubscribePage: React.FC = () => {
  const navigate = useNavigate()
  const { hasActiveSubscription } = useAppStore()
  const [subscriptionPrices, setSubscriptionPrices] = useState<
    SubscriptionPrice[]
  >([])
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
  console.log('✌️subscriptionPrices --->', subscriptionPrices)

  // Показываем кнопку "Назад" в Telegram WebApp
  useTelegramBackButton(true)

  useEffect(() => {
    if (hasActiveSubscription()) {
      navigate('/', { replace: true })
    }
  }, [hasActiveSubscription, navigate])

  useEffect(() => {
    const fetchSubscriptionPrices = async () => {
      try {
        const response = await apiClient.getSubscriptionPrices()
        console.log('API Response:', response)
        if (response.subscriptions && response.subscriptions.length > 0) {
          setSubscriptionPrices(response.subscriptions)
        }
      } catch (error) {
        console.error('Ошибка при получении цен подписок:', error)
      }
    }

    fetchSubscriptionPrices()
  }, [])

  const handlePaymentSelect = (currency: PaymentCurrency) => {
    console.log('Выбрана валюта для оплаты:', currency)
    setIsPaymentModalOpen(false)
  }

  const handleSubscribeClick = () => {
    setIsPaymentModalOpen(true)
  }

  return (
    <div className="card-page">
      <ImageSlider images={[subscribeHero]} title={'Подписка'} />
      <div className="card-page-content">
        <div className="subscribe-hero"></div>
        <div className="card-info">
          <h1 className="card-sub-title">SECRET CHAT</h1>
          <p className="card-sub-subtitle">
            Закрытый Telegram-канал для кондитеров от @pauline_cake
          </p>
        </div>

        <section className="subscribe-benefits">
          <h2 className="subscribe-benefits-title">Кому полезен чат?</h2>
          <div className="subscribe-benefits-box">
            <ul className="subscribe-benefits-list">
              <li>
                Кондитеру, который в поисках проверенных рецептов и вдохновения;
              </li>
              <li>
                Начинающему кондитеру для получения базовых знаний и поддержки
                опытных коллег;
              </li>
              <li>
                Профессионалу, который ищет способы масштабирования и
                оптимизации процессов.
              </li>
            </ul>
          </div>
        </section>
        <section className="subscribe-benefits">
          <h2 className="subscribe-benefits-title">Что внутри?</h2>
          <div
            className="subscribe-benefits-box"
            style={{ padding: '16px 0px' }}
          >
            <h2 className="subscribe-benefits-subtitle">
              Новый контент еженедельно
            </h2>
            <div className="subscribe-benefits-image-container">
              <img
                src={image1}
                alt="image1"
                className="subscribe-benefits-image"
              />
              <img
                src={image2}
                alt="image2"
                className="subscribe-benefits-image"
              />
              <img
                src={image3}
                alt="image3"
                className="subscribe-benefits-image"
              />
            </div>
            <h2 className="subscribe-benefits-subtitle">
              Пошаговые видеоуроки и подробные PDF-рецепты
            </h2>
            <div className="subscribe-benefits-image-container">
              <div className="subscribe-benefits-image-container-item">
                <img
                  src={image6}
                  alt="image1"
                  className="subscribe-benefits-image"
                />
                <p>1</p>
              </div>
              <div className="subscribe-benefits-image-container-item">
                <img
                  src={image4}
                  alt="image2"
                  className="subscribe-benefits-image"
                />
                <p>2</p>
              </div>
              <div className="subscribe-benefits-image-container-item">
                <img
                  src={image5}
                  alt="image3"
                  className="subscribe-benefits-image"
                />
                <p>3</p>
              </div>
            </div>
            <h2 className="subscribe-benefits-subtitle">
              Экспертные лекции и разборы{' '}
            </h2>
            <div className="subscribe-benefits-image-container-horizontal">
              <img src={image9} alt="image9" />
              <img src={image10} alt="image10" />
            </div>
            <h2 className="subscribe-benefits-subtitle">Помощь куратора</h2>
            <div className="subscribe-benefits-image-container-chat">
              <img
                src={image7}
                alt="image1"
                className="subscribe-benefits-image-chat"
              />
              <img
                src={image8}
                alt="image2"
                className="subscribe-benefits-image-chat"
              />
            </div>
            <h2 className="subscribe-benefits-subtitle">
              Комьюнити кондитеров и любителей выпечки
            </h2>
            <div className="subscribe-benefits-image-container-community">
              <img src={chanel} alt="chanel1" />
            </div>
            <h2 className="subscribe-benefits-subtitle">
              Общение с Полиной по теме и не только:)
            </h2>
            <div className="subscribe-benefits-image-container-community-pauline">
              <img src={massage1} alt="massage1" />
              <img src={massage2} alt="massage2" />
              <img src={massage3} alt="massage3" />
            </div>
          </div>
        </section>
        <div className="subscription-pricing-block">
          <img src={cloude} className="cloude-image cloude-image-1" alt="" />
          <img src={cloude} className="cloude-image cloude-image-2" alt="" />
          <img src={cloude} className="cloude-image cloude-image-3" alt="" />
          <h3 className="pricing-title">Стоимость подписки</h3>

          <div className="pricing-options">
            {subscriptionPrices.map(price => (
              <div key={price.subscription_info_id} className="pricing-option">
                <div className="price-main">
                  <p className="price-main-text">
                    {price.price.toLocaleString()}Р
                  </p>
                  <p className="price-period">/{price.suffix}</p>
                </div>
                {price.description && (
                  <div className="price-discount">{price.description}</div>
                )}
              </div>
            ))}
          </div>

          <button
            className="subscribe-button page-button"
            onClick={handleSubscribeClick}
          >
            Хочу в чат
          </button>
        </div>
      </div>

      <PaymentModal
        isOpen={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
        onPaymentSelect={handlePaymentSelect}
      />
    </div>
  )
}

export default SubscribePage
